import { render, staticRenderFns } from "./AppOffCanvas.vue?vue&type=template&id=722f070d"
import script from "./AppOffCanvas.vue?vue&type=script&lang=js"
export * from "./AppOffCanvas.vue?vue&type=script&lang=js"
import style0 from "./AppOffCanvas.vue?vue&type=style&index=0&id=722f070d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports